var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100 mh-100"},[_c('XYBubblesCanvas',{scopedSlots:_vm._u([{key:"widgets",fn:function({ widgetsContainerPosition }){return [(_vm.bubblesLegendsPosition === widgetsContainerPosition)?_c('BubblesLegendsAccordion'):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }